// extracted by mini-css-extract-plugin
module.exports = {"actions":"IEModal_actions__2P8Uh","image":"IEModal_image__2R6ld","content":"IEModal_content__rhuzP","title":"IEModal_title__2-MGX"};